// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;

function MM_cmp_export_proof(props) {
  var tempMode = props.tempMode;
  var onClose = props.onClose;
  var proofTableWithoutTypes = props.proofTableWithoutTypes;
  var proofTableWithTypes = props.proofTableWithTypes;
  var proofText = props.proofText;
  var match = Local_storage_utils.useStateFromLocalStorageBool("export-proof-show-proof-table", false, tempMode);
  var setShowProofTable = match[1];
  var showProofTable = match[0];
  var match$1 = Local_storage_utils.useStateFromLocalStorageBool("export-proof-essentials-only", false, tempMode);
  var setEssentialsOnly = match$1[1];
  var essentialsOnly = match$1[0];
  var match$2 = React.useState(function () {
        
      });
  var setCopiedToClipboard = match$2[1];
  var getTextToCopy = function (param) {
    return proofText + (
            showProofTable ? (
                essentialsOnly ? "\n\n" + proofTableWithoutTypes : "\n\n" + proofTableWithTypes
              ) : ""
          );
  };
  var rndProofTable = function (param) {
    if (showProofTable) {
      if (essentialsOnly) {
        return React.createElement("pre", undefined, proofTableWithoutTypes);
      } else {
        return React.createElement("pre", undefined, proofTableWithTypes);
      }
    } else {
      return null;
    }
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, React.createElement(Expln_React_Row.make, {
                            alignItems: "center",
                            children: Caml_option.some(null)
                          }, React.createElement(FormControlLabel, {
                                control: React.createElement(Checkbox, {
                                      checked: showProofTable,
                                      onChange: (function (param) {
                                          return Expln_React_common.evt2bool((function (b) {
                                                        Curry._1(setShowProofTable, (function (param) {
                                                                return b;
                                                              }));
                                                      }), param);
                                        })
                                    }),
                                label: "proof table"
                              }), React.createElement(FormControlLabel, {
                                control: React.createElement(Checkbox, {
                                      checked: essentialsOnly,
                                      onChange: (function (param) {
                                          return Expln_React_common.evt2bool((function (b) {
                                                        Curry._1(setEssentialsOnly, (function (param) {
                                                                return b;
                                                              }));
                                                      }), param);
                                        })
                                    }),
                                label: "essentials only",
                                disabled: !showProofTable
                              }), React.createElement(Button, {
                                onClick: (function (param) {
                                    MM_react_common.copyToClipboard(getTextToCopy(undefined));
                                    Curry._1(setCopiedToClipboard, (function (timerId) {
                                            if (timerId !== undefined) {
                                              Common.$$clearTimeout(Caml_option.valFromOption(timerId));
                                            }
                                            return Caml_option.some(Common.$$setTimeout((function (param) {
                                                              Curry._1(setCopiedToClipboard, (function (param) {
                                                                      
                                                                    }));
                                                            }), 1000));
                                          }));
                                  }),
                                variant: "contained",
                                style: {
                                  width: "90px"
                                },
                                children: Caml_option.some(Belt_Option.isSome(match$2[0]) ? "Copied" : "Copy")
                              }), React.createElement(Button, {
                                onClick: (function (param) {
                                    Curry._1(onClose, undefined);
                                  }),
                                children: "Close"
                              })), React.createElement("pre", {
                            style: {
                              whiteSpace: "pre-wrap",
                              overflowWrap: "break-word"
                            }
                          }, proofText), rndProofTable(undefined)))
            });
}

var make = MM_cmp_export_proof;

exports.make = make;
/* react Not a pure module */
